module.exports = __webpack_public_path__ + "img/25800.5670baba.jpg";